import { useState } from "react";
import { api, eur, errMsg } from "@/lib/api";

const field = "h-11 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none focus:border-[#0066FF] focus:bg-white";
const PAY = { pending: "In attesa di pagamento", paid: "Pagato", expired: "Scaduto", failed: "Non riuscito", refunded: "Rimborsato", partially_refunded: "Rimborsato parzialmente" };

export default function OrderLookup() {
  const [q, setQ] = useState({ number: "", email: "" });
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      setO((await api.post("/orders/lookup", q)).data);
    } catch (x) {
      setO(null);
      setErr(errMsg(x));
    }
  };
  return (
    <div className="mx-auto max-w-2xl px-4 pt-12 sm:px-6" data-testid="order-lookup-page">
      <h1 className="font-display text-4xl font-bold tracking-[-0.03em] text-[#0A0B0E]">Il mio ordine</h1>
      <p className="mt-3 text-slate-500">Inserisci il numero d'ordine (es. LT-2026-00001) e l'email usata per l'acquisto.</p>
      <form onSubmit={submit} className="mt-8 grid gap-3 sm:grid-cols-[1fr_1fr_auto]">
        <input required value={q.number} onChange={(e) => setQ({ ...q, number: e.target.value })} placeholder="Numero ordine" className={field} data-testid="lookup-number" />
        <input required type="email" value={q.email} onChange={(e) => setQ({ ...q, email: e.target.value })} placeholder="Email" className={field} data-testid="lookup-email" />
        <button className="h-11 rounded-xl bg-[#0066FF] px-6 text-sm font-semibold text-white" data-testid="lookup-submit">Cerca</button>
      </form>
      {err && <p className="mt-4 text-sm text-red-600" data-testid="lookup-error">{err}</p>}
      {o && (
        <div className="mt-8 space-y-4 rounded-3xl border border-slate-200 bg-[#F5F7FA] p-6 text-sm text-slate-900" data-testid="lookup-result">
          <div className="flex flex-wrap justify-between gap-2"><b>{o.number}</b><span>{new Date(o.created_at).toLocaleDateString("it-IT")}</span></div>
          <p>Stato: <b data-testid="lookup-status">{o.status}</b> · Pagamento: {PAY[o.payment_status] || o.payment_status}</p>
          {o.tracking ? (
            <p data-testid="lookup-tracking">Corriere: <b>{o.carrier}</b> · Tracking: <b>{o.tracking}</b>{o.tracking_url && <> · <a href={o.tracking_url} target="_blank" rel="noopener noreferrer" className="text-[#0066FF] underline">Segui la spedizione</a></>}</p>
          ) : <p className="text-slate-500">Il codice di tracciamento sarà disponibile dopo l'affidamento al corriere.</p>}
          <ul className="border-t border-slate-200 pt-3">{o.items.map((i, k) => <li key={k} className="flex justify-between py-1"><span>{i.name} × {i.qty}</span><span>{eur(i.line_total)}</span></li>)}</ul>
          <p className="text-right font-display text-lg font-bold">Totale {eur(o.total)}</p>
        </div>
      )}
    </div>
  );
}
